import { __awaiter } from "tslib";
import { ErrorLogService } from "@/servicesTs/models/general/errorLog";
const moduleErrorLog = {
    namespaced: true,
    state: {
        loading: false,
        errorsLogs: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getErrorsLogs(state) {
            return state.errorsLogs;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setErrorsLogs(state, data) {
            state.errorsLogs = data;
        },
        setPageErrorsLogs(state, page) {
            state.errorsLogs.current_page = page;
        },
    },
    actions: {
        getErrorsLogs({ commit, state }, data) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const ERRORS_LOGS = yield ErrorLogService.getFilterAll(Object.assign(Object.assign({}, data), { page: state.errorsLogs.current_page }));
                commit("setErrorsLogs", ERRORS_LOGS);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleErrorLog;
